"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cache = void 0;
const lru_cache_1 = require("lru-cache");
exports.cache = new lru_cache_1.LRUCache({
    max: 200,
    maxSize: 500 * 1024,
    sizeCalculation: (value, key) => {
        return typeof value === 'string'
            ? value.length
            : new TextEncoder().encode(JSON.stringify(value)).length;
    },
    ttl: 1000 * 60 * 5,
    allowStale: false,
});
//# sourceMappingURL=cache.js.map